import React from "react";

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    color?: string;
    icon?: "plus" | "back";
    onClick?: (event: any) => void;
}

const Button: React.FC<ButtonProps> = ({
    children,
    className = "btn",
    type = "button",
    color = "default",
    icon,
    onClick,
    ...props
}) => {
    return (
        <button type={type} className={`${className} btn--${color} ${icon ? icon : ""}`} onClick={onClick} {...props}>
            {children}
        </button>
    );
};
export default Button;
